import { render, staticRenderFns } from "./YouTubeReplyComment.vue?vue&type=template&id=6af8d346&scoped=true"
import script from "./YouTubeReplyComment.vue?vue&type=script&lang=js"
export * from "./YouTubeReplyComment.vue?vue&type=script&lang=js"
import style0 from "./YouTubeReplyComment.vue?vue&type=style&index=0&id=6af8d346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af8d346",
  null
  
)

export default component.exports